const lossControlPrintStyles = `
  @page {
    size: A4 landscape;
    margin: 6mm;
  }

  @media print {
    html,
    body {
      background: #fff !important;
      color: #000 !important;
      font-size: 9px !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .loss-control-page,
    .loss-control-content {
      min-height: 0 !important;
      max-width: none !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .loss-control-no-print,
    .loss-control-report-controls,
    .loss-control-report-summary-badges {
      display: none !important;
    }

    .loss-control-report {
      background: #fff !important;
      border: 0 !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      color: #000 !important;
      overflow: visible !important;
    }

    .loss-control-report * {
      -webkit-print-color-adjust: economy !important;
      print-color-adjust: economy !important;
    }

    .loss-control-report-header {
      align-items: flex-start !important;
      border-bottom: 1px solid #000 !important;
      display: flex !important;
      flex-direction: row !important;
      gap: 3mm !important;
      justify-content: space-between !important;
      padding: 0 0 2mm !important;
    }

    .loss-control-report-header h2 {
      color: #000 !important;
      font-size: 12pt !important;
      line-height: 1.05 !important;
      margin: 0 !important;
    }

    .loss-control-report-header p,
    .loss-control-print-meta {
      color: #000 !important;
      font-size: 7pt !important;
      line-height: 1.15 !important;
      margin: 0 !important;
    }

    .loss-control-print-meta {
      display: block !important;
      margin-top: 1mm !important;
    }

    .loss-control-report-badge {
      background: transparent !important;
      border: 1px solid #000 !important;
      color: #000 !important;
      font-size: 6pt !important;
      line-height: 1 !important;
      padding: 0.5mm 1mm !important;
    }

    .loss-control-report-table {
      border-collapse: collapse !important;
      table-layout: fixed !important;
      width: 100% !important;
    }

    .loss-control-report-table thead {
      display: table-header-group !important;
    }

    .loss-control-report-table tbody {
      display: table-row-group !important;
    }

    .loss-control-report-table tr {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }

    .loss-control-report-table th {
      background: #fff !important;
      border-bottom: 1px solid #000 !important;
      color: #000 !important;
      font-size: 6.5pt !important;
      line-height: 1 !important;
      padding: 1.2mm 1mm !important;
    }

    .loss-control-report-table td {
      border-color: #aaa !important;
      color: #000 !important;
      font-size: 7pt !important;
      line-height: 1.05 !important;
      min-width: 0 !important;
      padding: 0.8mm 1mm !important;
      vertical-align: middle !important;
    }

    .loss-control-report-table th:nth-child(1) { width: 15%; }
    .loss-control-report-table th:nth-child(2) { width: 29%; }
    .loss-control-report-table th:nth-child(3) { width: 27%; }
    .loss-control-report-table th:nth-child(4) { width: 12%; }
    .loss-control-report-table th:nth-child(5) { width: 8%; }
    .loss-control-report-table th:nth-child(6) { width: 9%; }

    .loss-control-report-table td:first-child {
      border-left-color: #000 !important;
      border-left-width: 1px !important;
      white-space: nowrap !important;
    }

    .loss-control-report-table td:nth-child(4),
    .loss-control-report-table td:nth-child(5),
    .loss-control-report-table td:nth-child(6) {
      white-space: nowrap !important;
    }

    .loss-control-report-table p {
      color: #000 !important;
      display: inline !important;
      font-size: inherit !important;
      line-height: 1.05 !important;
      margin: 0 !important;
    }

    .loss-control-report-table .loss-control-product-details {
      font-size: 6pt !important;
      font-weight: 400 !important;
      margin-left: 1mm !important;
    }

    .loss-control-report-table .loss-control-product-details::before {
      content: " — ";
    }

    .loss-control-report-table .loss-control-ean {
      display: none !important;
    }

    .loss-control-report-table .loss-control-classification-subgroup::before {
      content: " / ";
    }

    .loss-control-report-table .loss-control-status-badge {
      background: transparent !important;
      border: 0 !important;
      color: #000 !important;
      font-size: 6.5pt !important;
      line-height: 1 !important;
      padding: 0 !important;
    }

    .loss-control-report-footer {
      align-items: flex-start !important;
      border-top: 1px solid #000 !important;
      break-inside: avoid !important;
      color: #000 !important;
      font-size: 7pt !important;
      padding: 1.5mm 0 0 !important;
      page-break-inside: avoid !important;
    }

    .loss-control-report-footer p {
      color: #000 !important;
      font-size: 7pt !important;
      line-height: 1.15 !important;
    }
  }
`;

export default lossControlPrintStyles;
